<template>
  <div class="error-page">
    <div class="error-txt">
      <div class="title">
        <strong>404</strong>
        <p>찾을 수 없는 페이지 입니다.</p>
      </div>
      <div class="dec">
        <p class="ko">요청하신 페이지가 사라졌거나, 잘못된 경로를 이용하셨어요 :)</p>
        <p class="en">We can't seem to find the page you're looking for.</p>
      </div>
      <div class="link-box">
        <router-link to="/" class="link-txt">
          <span>메인으로</span>
        </router-link>
        <a href="#" class="link-txt" @click.prevent="$router.go(-1)">
          <span>이전 페이지</span>
        </a>
      </div>
    </div>
    <div class="fix-txt">
      Make<br />
      Greatness<br />
      <span>e motion global</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: "error404",
    metaInfo() {
      return {
        title: "404",
        titleTemplate: "%s | e · motion",
        meta: [
          {
            property: "og:title",
            content: "404 | e · motion",
            vmid: "og:title"
          },
          {
            property: "og:site_name",
            content: "이모션글로벌 | MAKE GREATNESS emotion global",
            vmid: "og:site_name"
          },
          {
            property: "og:url",
            content: "https://www.emotion.co.kr/404/",
            vmid: "og:url"
          }
        ]
      };
    }
  };
</script>
<style scoped lang="scss">
  .error-page {
    @include globalWidth();
    display: flex;
    padding: 140px 30px;
    align-items: center;
    box-sizing: border-box;
    min-height: 100vh;
    .error-txt {
      width: 740px;
      .title {
        strong {
          @include montserrat();
          font-size: 220px;
          line-height: 200px;
          font-weight: 900;
          letter-spacing: 0.03em;
        }
        p {
          margin-top: 94px;
          font-size: 44px;
          font-weight: bold;
          letter-spacing: -0.05em;
        }
      }
      .dec {
        margin-top: 40px;
        &:before {
          content: "";
          display: block;
          width: 12px;
          height: 12px;
          margin-bottom: 12px;
          border-radius: 100%;
          background: $red;
        }
        .ko {
          font-size: 18px;
          line-height: 30px;
          letter-spacing: -0.03em;
        }
        .en {
          @include montserrat();
          font-size: 14px;
          line-height: 30px;
        }
      }
      .link-box {
        margin: 87px 0 0 -10px;
        .link-txt {
          display: inline-flex;
          padding: 10px 10px;
          font-size: 14px;
          line-height: 21px;
          span {
            display: block;
            color: #000;
            border-bottom: 1px solid #000;
          }
        }
      }
    }
    .fix-txt {
      @include montserrat();
      font-size: 36px;
      line-height: 45px;
      font-weight: 900;
      span {
        color: $red;
      }
      &:before {
        content: "";
        display: block;
        width: 65px;
        height: 65px;
        margin: 65px 0 109px 0;
        border-radius: 100%;
        background: $red;
      }
    }
  }
</style>
